import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router, ActivatedRoute, Data } from '@angular/router';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ContatoStatus } from '../models/contato-status';
import { ContatoStatusService } from '../services/contato-status.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-contato-status',
  templateUrl: './contato-status.component.html',
  styleUrls: ['./contato-status.component.scss']
})
export class ContatoStatusComponent implements OnInit {

  // variáveis
  contatosStatus: ContatoStatus[] = [];
  contatosStatusFiltrados: ContatoStatus[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  texto = 'Contato';

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  // construtor
  constructor(private contatoStatusService: ContatoStatusService, private utilitarioService: UtilitarioService,
    private router: Router, private paginatorService: PaginatorService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private route: ActivatedRoute) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarStatusContato();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.contatosStatus = this.contatosStatus.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'nome': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.contatosStatusFiltrados = this.contatosStatus.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase()));

    if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
      this.itensPorPagina = 10;
    }

    this.paginacao.total = this.contatosStatusFiltrados.length;
    this.paginator.firstPage();

    this.mudaDePagina({ length: this.contatosStatus.length, pageIndex: 0, pageSize: this.itensPorPagina });
  }

  buscarStatusContato() {
    this.carregandoService.mostra('buscarStatusContato');
    this.carregando = true;

    this.contatoStatusService.consultar().subscribe((data: any) => {
      this.paginator.firstPage();
      this.contatosStatus = data;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = this.contatosStatus.length;

      this.mudaDePagina({ length: this.contatosStatus.length, pageIndex: 0, pageSize: this.itensPorPagina });

      this.carregando = false;
      this.carregandoService.esconde('buscarStatusContato');

    }, (erro) => {
      this.carregandoService.esconde('buscarStatusContato');
      this.notificacaoService.erro(erro);
    });
  }

  novoContatoStatus() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarContatoStatus(contatoStatus: ContatoStatus) {
    this.router.navigate(['editar', contatoStatus.id], { relativeTo: this.route });
  }

  excluirContatoStatus(contatoStatus: ContatoStatus) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Status de ' + this.texto + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiContatoStatus');
        this.contatoStatusService.excluir(contatoStatus.id).subscribe(resp => {
          this.notificacaoService.sucesso('Status de ' + this.texto + ' excluído com sucesso!!!');
          this.carregandoService.esconde('excluiContatoStatus');
          this.buscarStatusContato();
        }, (erro) => {
          this.carregandoService.esconde('excluiContatoStatus');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.contatosStatusFiltrados = this.contatosStatus.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase())).
      slice(pageEvent.pageIndex * pageEvent.pageSize,
        (pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize);
  }

  ngOnDestroy(): void { }

}